// src/pages/league-dashboard/standings/TeamLogo.js
//
// Extracted from inline closure in LeagueStandings.js per IMPORTANT
// batch 6 commit 6a (refactor only — no behavior change). Shared
// between RotisserieTable and HeadToHeadStandings.
import React from 'react';
import { dynastyTokens } from '../../../services/colorService';

const TeamLogo = ({ team, size = 'small' }) => {
  const sizeClasses = size === 'small' ? 'w-6 h-6 text-[10px]' : 'w-8 h-8 text-xs';

  if (team.team_logo_url) {
    return (
      <>
        <img
          src={team.team_logo_url}
          alt={`${team.team_name} Logo`}
          className={`${sizeClasses} rounded object-cover border border-neutral-700`}
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextElementSibling.style.display = 'flex';
          }}
        />
        <div
          className={`${sizeClasses} rounded border border-neutral-700 hidden items-center justify-center font-bold`}
          style={{
            background: team.team_colors?.primary ?
              `linear-gradient(135deg, ${team.team_colors.primary}, ${team.team_colors.secondary || team.team_colors.primary})` :
              `linear-gradient(135deg, ${dynastyTokens.colors.primary}, ${dynastyTokens.colors.primaryDark})`,
            color: team.team_colors?.text || dynastyTokens.colors.neutral[900],
            display: 'none'
          }}
        >
          {team.team_name?.substring(0, 2).toUpperCase() || 'T'}
        </div>
      </>
    );
  }

  return (
    <div
      className={`${sizeClasses} rounded border border-neutral-700 flex items-center justify-center font-bold`}
      style={{
        background: team.team_colors?.primary ?
          `linear-gradient(135deg, ${team.team_colors.primary}, ${team.team_colors.secondary || team.team_colors.primary})` :
          'linear-gradient(135deg, #FFD700, #8B7500)',
        color: team.team_colors?.text || '#000000'
      }}
    >
      {team.team_name?.substring(0, 2).toUpperCase() || 'T'}
    </div>
  );
};

export default TeamLogo;
